import { EligibilityResultsScreen } from "@/interactors/EligibilityResultsScreen";

export default function Results() {
  return <EligibilityResultsScreen />;
}
